import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CommonCodeValueRequest } from '../types/code';

/**
 * PATCH /api/eraf/codes/groups/{groupCode}/items/{itemCode} — 코드 항목 수정
 * 성공 시 ['common-code', 'items', groupCode] 쿼리 무효화
 */
export function useUpdateCodeItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      groupCode,
      itemCode,
      body,
    }: {
      groupCode: string;
      itemCode: string;
      body: Partial<CommonCodeValueRequest>;
    }) => codeApi.updateItem(groupCode, itemCode, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['common-code', 'items', variables.groupCode],
      });
    },
  });
}
